/* eslint-disable no-param-reassign */
import storeAb from "../../vue-product-details-print-ab/store/store";

window.jiffy ||= {};
// Always use storeAb (experiment winner)
window.jiffy.madeStore = storeAb;
export default storeAb;
